/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-one-expression-per-line */
import { Stack, HStack, Box, theme, Text, useToast } from '@chakra-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import uniq from 'lodash/uniq';
import FormLabelInput from '../../formInputs/FormLabelInput';
import FormTextInput from '../../formInputs/FormTextInput';
import AddFollowup from './AddFollowup';
import { useGetItemProperty } from '../../hooks/useGetItemProperty';
import SelectFollowupOption from './SelectFollowupOption';
import { DRAG_ITEM_TYPES } from '../../constants';
import { DropTarget, FieldOptionT, FormBuilderComponentProps, FormFieldT, FormItemT, FormSectionT } from '../../types';
import { getOptionIdForItem, isFieldSchema, isSectionSchema } from '../../utils';
import { FormFollowup } from '../../FormFollowup';
import { useUpdateFormItem } from '../../hooks/useUpdateFormItem';
import { ComponentInputTypeT } from '../../schemas/types';
import {
  FORM_COMPONENT_ADVANCED_INPUT_TYPE,
  FORM_COMPONENT_BASIC_INPUT_TYPE,
  FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE,
} from '../../schemas/formComponentInputTypeSchema';
import { SECTION_NAMES } from '../../schemas/formAdvancedSections';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import ComponentButtonPreview from '../ComponentButtonPreview';

// eslint-disable-next-line import/no-default-export
export default function YesNoField({
  fieldId,
  labelRightRenderer,
  isAdvanced,
  path,
}: FormBuilderComponentProps): JSX.Element | null {
  const { t } = useTranslation('hrFormTemplate');
  const toast = useToast();

  const [followUpOptionIdsDisplaying, setFollowUpOptionIdsDisplaying] = useState<string[]>([]);
  const handleOnChange = useUpdateFormItem();

  const draggedItem = useStoreState((state) => state.formBuilder.draggedItem);
  const language = useStoreState((state) => state.formBuilder.currentLanguage);
  const addItemToFollowup = useStoreActions((actions) => actions.formBuilder.addItemToFollowup);
  const moveItemToFollowup = useStoreActions((actions) => actions.formBuilder.moveItemToFollowup);

  const allSchemaOptions = useGetItemProperty<FieldOptionT[]>(fieldId, 'optionList') || [];

  const followUpQuestionsInSchema = useGetItemProperty<(FormFieldT | FormSectionT)[]>(fieldId, 'followUpQuestionList') || [];

  useEffect(() => {
    if (followUpQuestionsInSchema && followUpQuestionsInSchema.length > 0) {
      if (followUpQuestionsInSchema && followUpQuestionsInSchema.length > 0) {
        const ids = uniq(followUpQuestionsInSchema.map((fuItem) => getOptionIdForItem(fuItem)).filter(Boolean) as string[]);
        setFollowUpOptionIdsDisplaying(ids);
      } else {
        setFollowUpOptionIdsDisplaying([]);
      }
    }
  }, [followUpQuestionsInSchema]);

  const handleDisableToast = useCallback(
    (isCopy: boolean, itemData: ComponentInputTypeT | FormItemT) => {
      const showErrorToast = (messageKey: string, params = {}) => {
        toast({
          description: t(messageKey, params),
          status: 'error',
          isClosable: true,
        });
      };

      let errorKey = null;
      let errorParams = {};

      if (isCopy) {
        const dataType = itemData as ComponentInputTypeT;
        switch (dataType) {
          case FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo:
            errorKey = 'formBuilder.followups.errors.maxDepth';
            errorParams = { MAX_FOLLOW_UP_DEPTH: 1 };
            break;
          case FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview:
            errorKey = 'formBuilder.followups.errors.noDocumentReview';
            break;
          case FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE.section:
            errorKey = 'formBuilder.followups.errors.noSection';
            break;
          case FORM_COMPONENT_ADVANCED_INPUT_TYPE.fullName:
            errorKey = 'formBuilder.followups.errors.noFullname';
            break;
          case FORM_COMPONENT_ADVANCED_INPUT_TYPE.addressValidator:
            errorKey = 'formBuilder.followups.errors.noCompleteAddress';
            break;
          case FORM_COMPONENT_ADVANCED_INPUT_TYPE.emergencyContact:
            errorKey = 'formBuilder.followups.errors.noEmergencyContact';
            break;
        }
      } else {
        const dataType = itemData as FormItemT;
        if (isFieldSchema(dataType)) {
          switch (dataType.inputType) {
            case FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo:
              errorKey = 'formBuilder.followups.errors.maxDepth';
              errorParams = { MAX_FOLLOW_UP_DEPTH: 1 };
              break;
            case FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview:
              errorKey = 'formBuilder.followups.errors.noDocumentReview';
              break;
          }
        } else if (isSectionSchema(dataType)) {
          if (!dataType.isAdvanced) {
            errorKey = 'formBuilder.followups.errors.noSection';
          } else if (dataType.section === SECTION_NAMES.fullName) {
            errorKey = 'formBuilder.followups.errors.noFullname';
          } else if (dataType.section === SECTION_NAMES.emergencyContact) {
            errorKey = 'formBuilder.followups.errors.noEmergencyContact';
          }
        }
      }

      if (errorKey) {
        showErrorToast(errorKey, errorParams);
        return true;
      }

      return false;
    },
    [toast],
  );

  const handleDropInFollowUp = useCallback(
    (dropTarget: DropTarget, optionId?: string) => {
      if (!draggedItem || !optionId || isAdvanced) return;
      const isCopy = draggedItem.type === DRAG_ITEM_TYPES.PALETTE;

      const isDisabled = handleDisableToast(isCopy, draggedItem.itemData);
      if (isDisabled) return;
      const actionType = isCopy ? addItemToFollowup : moveItemToFollowup;
      actionType({ draggedItem, dropTarget: { ...dropTarget, followupPath: path }, optionId });
    },
    [addItemToFollowup, moveItemToFollowup, draggedItem],
  );

  const handleFollowUpOptionChange = useCallback(
    (newSelectedOptionId: string, oldOptionIdForBlock: string) => {
      const updateOptionIdRecursively = (items: FormItemT[], newOptionId: string) => {
        items?.forEach((item) => {
          if (isFieldSchema(item)) {
            item.optionId = newOptionId;
          } else if (isSectionSchema(item)) {
            updateOptionIdRecursively(item.fields, newOptionId);
          }
        });
      };

      const relevantFollowUpItems = followUpQuestionsInSchema?.filter((item) => item.optionId === oldOptionIdForBlock);

      if (relevantFollowUpItems?.length) {
        relevantFollowUpItems.forEach((followUpItem) => {
          followUpItem.optionId = newSelectedOptionId;

          if (isSectionSchema(followUpItem)) {
            updateOptionIdRecursively(followUpItem.fields, newSelectedOptionId);
          }
        });
      }

      handleOnChange(fieldId, { followUpQuestionList: relevantFollowUpItems });
      setFollowUpOptionIdsDisplaying((prevOptionIds) =>
        uniq(prevOptionIds.map((id) => (id === oldOptionIdForBlock ? newSelectedOptionId : id))),
      );
    },
    [fieldId, followUpQuestionsInSchema, handleOnChange],
  );

  const handleAddNewFollowUpBlock = useCallback((newOptionIdToAdd: string) => {
    setFollowUpOptionIdsDisplaying((prev) => uniq([...prev, newOptionIdToAdd]));
  }, []);

  if (!fieldId) {
    return null;
  }

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.yesNo')} isAdvanced={isAdvanced || false} />
      <HStack direction={allSchemaOptions?.some((item) => item?.tag) ? 'column' : 'row'}>
        {allSchemaOptions.map((option, index) => {
          return <ComponentButtonPreview key={option.id || index} label={option.text?.[language] || ''} />;
        })}
      </HStack>

      <Box>
        <AddFollowup
          fieldId={fieldId}
          currentlyRenderedOptionIds={followUpOptionIdsDisplaying}
          setFollowUpOptions={handleAddNewFollowUpBlock}
        />
      </Box>

      {followUpOptionIdsDisplaying?.map((optionIdForBlock, index) => (
        <Box
          key={optionIdForBlock}
          p={3}
          mb={3}
          mt={4}
          sx={{
            backgroundColor: '#f9fcff99',
            border: `1px solid #e5eef7`,
            padding: theme.space[4],
            borderRadius: theme.radii.md,
          }}
        >
          <HStack justify="space-between">
            <HStack alignItems="center">
              <Text fontSize={12} fontWeight="normal">
                {t('formBuilder.showNextQuestion')}:
              </Text>
              <SelectFollowupOption
                currentOptionIdForBlock={optionIdForBlock}
                onChange={handleFollowUpOptionChange}
                isAdvanced={isAdvanced}
                allSchemaOptions={allSchemaOptions}
                allFollowUpOptionIdsInUse={followUpOptionIdsDisplaying}
              />
            </HStack>
          </HStack>

          <FormFollowup
            optionId={optionIdForBlock}
            followUps={followUpQuestionsInSchema}
            fieldId={fieldId}
            path={path || []}
            index={index}
            parentIsAdvanced={isAdvanced}
            handleDropInFollowUp={handleDropInFollowUp}
          />
        </Box>
      ))}
    </Stack>
  );
}
